import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../../utils/axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import { MutationKeys } from "../../mutation/mutation.enum";
import {
  UpdateSGTemplateResponse,
  UpdateSGTemplateVariables,
} from "../../../models/Interface/SGTemplate.interface";

const updateSGTemplate = async ({ id, data }: UpdateSGTemplateVariables) => {
  const response = await axiosInstance.patch<UpdateSGTemplateResponse>(
    `/sg-template-management/${id}`,
    data
  );
  return response.data;
};

const useUpdateSGTemplate = (
  options?: Partial<
    UseMutationOptions<
      UpdateSGTemplateResponse,
      AxiosError<IErrorResponse>,
      UpdateSGTemplateVariables
    >
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKeys.UPDATE_SG_TEMPLATE],
    mutationFn: updateSGTemplate,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SG_TEMPLATES] });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useUpdateSGTemplate;
